import Drag from "./drag.vue";
import Drop from "./drop.vue";

const VueLeave = {
  install(Vue) {
    Vue.component(Drag.name, Drag);
    Vue.component(Drop.name, Drop);
  },
};

if (typeof window !== "undefined" && window.Vue) {
  window.Vue.use(VueLeave);
}

export default VueLeave;
